import React from 'react';
import LeadForm from './LeadForm';
import { saveGameUserInfoLSAction } from '@/redux/action/game';
import { IGameLeadInput } from '@/interface/gameLead';
import { IGameScreen } from '@/interface/game';

const LeadScreen = ({
  leadScreen,
  style,
  gameId,
  score,
  onSetScreen,
}: LeadScreenProps) => {
  const onSetIsSubmitted = async (data?: IGameLeadInput) => {
    await saveGameUserInfoLSAction(gameId, data);

    let type = 'END_SCREEN';
    if (leadScreen?.position === 'START') {
      type = 'START';
    }
    onSetScreen(type);
  };

  return (
    <div
      className={`z-10 bg-[#ffffff] overflow-hidden h-full w-full absolute ${style}`}
      id="lead_screen"
    >
      <LeadForm
        data={leadScreen}
        score={score}
        gameId={gameId}
        onClose={onSetIsSubmitted}
      />
    </div>
  );
};
type LeadScreenProps = {
  leadScreen: IGameScreen;
  style?: string;
  gameId: string;
  score: number;
  onSetScreen: (a: string) => void;
};
export default LeadScreen;
